const AppLayout = (resolve) =>
  require(['@/components/layout/AppLayout'], resolve);
const _import = (path, subPath) =>
  require('@/components/page/meetingplan/' +
    path +
    (subPath ? `/${subPath}/index` : '/index'));

const routes = {
  path: '/meetingplan',
  component: AppLayout,
  meta: {
    title: 'meetingplan.authorizedtask.title',
    hidden: false,
    name: 'meetingplan-authorizedtask'
  },
  redirect: 'authorizedtask',
  children: [
    {
      path: 'authorizedtask',
      name: 'meetingplan-authorizedtask',
      meta: {
        title: 'meetingplan.authorizedtask',        
        hidden: true,
      },
      component: _import('authorizedtask')
    },
    {
      path: 'authorizedtask/view/:id',
      name: 'meetingplan-authorizedtask-view',
      meta: {
        title: 'meetingplan.authorizedtask.view',
        hidden: false,
      },
      component: _import('authorizedtask','view')
    }
  ]
};

export default routes;



// WEBPACK FOOTER //
// ./src/router/meetingplanauthorizedtask.js